export const loadingConstant = {
    OPEN: 'LOADING_OPEN',
    CLOSE: 'LOADING_CLOSE',
    OPEN_WITH_STYLE:'OPEN_WITH_STYLE'
};
